import { render, staticRenderFns } from "./PrintNotification.vue?vue&type=template&id=0b92ce3c&scoped=true&"
import script from "./PrintNotification.vue?vue&type=script&lang=js&"
export * from "./PrintNotification.vue?vue&type=script&lang=js&"
import style0 from "./PrintNotification.vue?vue&type=style&index=0&id=0b92ce3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b92ce3c",
  null
  
)

export default component.exports